import { types } from 'actions/ai';

const defaultState = {
  productName: '',
  productDescription: '',
  keywords: [],
  restoringState: true,
  activityAutoSelectCount: 0,
};

const REDUCER = {
  [types.SAVE_FORM_VALUES]: (state, action) => {
    return {
      ...state,
      ...action.payload,
    };
  },
  [types.RESTORE_STATE]: (state, action) => {
    if (!action.payload) {
      return {
        ...state,
        restoringState: false,
      };
    }

    let restoredState = JSON.parse(JSON.stringify(action.payload));
    restoredState = {
      ...defaultState,
      ...restoredState,
    };
    restoredState.restoringState = false;

    return restoredState;
  },
};

const reducer = (state = defaultState, action) => {
  const handler = REDUCER[action.type];
  return handler ? handler(state, action) : state;
};

export default reducer;
